<template>
  <div>
    <div class="cpt-rule-fixed-container" 
      :class="[cc.pos, {'no-fixed': cc.is_doc_show, 'absolute': !cc.is_doc_show && cc.is_absolute}]"
      :style="{
        'left': cc.pos == 'left' && !cc.is_doc_show ? 'max(calc(50% - 240px), 0px)' : '',
        'right': cc.pos == 'right' && !cc.is_doc_show ? 'max(calc(50% - 240px), 0px)' : '',
        'top': cc.page_top || 0,
        'bottom': cc.is_doc_show ? cc.page_bottom : '',
        'margin-top': cc.is_doc_show ? cc.margin_top + 'px' : '',
        'margin-bottom': cc.is_doc_show ? cc.margin_bot + 'px' : '',
        'margin-left': cc.is_doc_show ? cc.margin_left + 'px' : '',
        'margin-right': cc.is_doc_show ? cc.margin_right + 'px' : '',
      }" @click="showModal = true">
      <img :src="cc.bt_img" 
        :style="{
          'object-fit': !cc.bt_width || !cc.bt_height ? 'contain' : '',
          'width': cc.bt_width ? cc.bt_width + 'px' : '',
          'height': cc.bt_height ? cc.bt_height + 'px' : ''
        }"/>
    </div>
    <RuleModal
      :show.sync="showModal"
      :title="cc.title"
      :bg_color="cc.modal_bg_color"
      :tx_color="cc.modal_title_color"
      :btn_text="cc.modal_btn_text"
      :btn_bg_color="cc.modal_btn_bg_color"
      :btn_text_color="cc.modal_btn_text_color"
    >
      <div class="rule-list" :style="{color: cc.modal_tx_color}">
        <div v-for="(item, index) in cc.rule_list" :key="index" class="rule-item">
          {{item}}
          <p class="rule-index" v-if="item">{{ (index + 1) + '.' }}</p>
        </div>
      </div>
    </RuleModal>
  </div>
</template>

<script>
import { utils } from '_lib/utils'
import { ComponentCommonMixin } from '../mixin'
import RuleModal from './RuleModal'
export default {
  data () {
    return {
      modal_msg: '',
      modal_desc: '',
      confirm_btn_text: '',
      front_task_jump_protocol: '',
      isFullScreen: false,
      showModal: false
    }
  },
  mixins: [ComponentCommonMixin],
  mounted() {
    this.isFullScreen = utils.isFullScreen()
  },
  components: {
    RuleModal
  }
}
</script>

<style lang="less" scoped>
.cpt-rule-fixed-container {
  font-weight: 800;
  font-size: 12.5px;
  writing-mode: vertical-lr;
  position: fixed;
  z-index: 100;
  &.right {
    right: 0;
  }
  &.left {
    left: 0;
  }
  &.no-fixed {
    position: static;
    z-index: 0;
    margin: 0 14px;
    &.right {
      margin-left: auto !important;
    }
    margin: 0 14px;
    &.left {
      margin-right: auto !important;
    }
    &.center {
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }
  &.absolute {
    position: absolute;
  }
}
.rule-list {
  padding: 8px 0 16px 15px;
  .rule-item {
    position: relative;
    .rule-index {
      position: absolute;
      left: -15px;
      top: 0;
    }
  }
}
</style>